(function(window, angular){'use strict';

var ngModule = angular.module('pp.services.recaptcha', []);

ngModule.service('recaptchaService', ['$window', '$q', function ($window, $q) {

    function createTest(key, action) {
        return function () {
            var deferred = $q.defer();

            $window.grecaptcha.enterprise.ready(function () {
                $window.grecaptcha.enterprise.execute(key, {
                    action: action
                }).then(function (result) {
                    deferred.resolve(result);
                }, function (err) {
                    deferred.reject(err);
                });
            });

            return deferred.promise;
        };
    }

    return {
        createTest: createTest
    };
}]);
})(window, window.angular);